/* tslint:disable */
import { setEnvironmentVariables } from 'mt-shared';

setEnvironmentVariables({
  ENVIRONMENT: ENVIRONMENT,
  API_URL_EU: API_URL_EU,
  API_URL: API_URL,
  ACCOUNT_URL_EU: ACCOUNT_URL_EU,
  ACCOUNT_URL: ACCOUNT_URL,
  STATIC_HOST_URL_EU: STATIC_HOST_URL_EU,
  STATIC_HOST_URL: STATIC_HOST_URL,
  SERVER_URL_EU:  SERVER_URL_EU,
  SERVER_URL: SERVER_URL,
  WEBSITE_URL_EU: WEBSITE_URL_EU,
  WEBSITE_URL: WEBSITE_URL,
  SENDBIRD_EU_APP_ID: SENDBIRD_EU_APP_ID,
  SENDBIRD_APP_ID: SENDBIRD_APP_ID,
  GOOGLE_MAPS_KEY_EU: GOOGLE_MAPS_KEY_EU,
  GOOGLE_MAPS_KEY: GOOGLE_MAPS_KEY,
});
